module Meevo.Plugins.BasicEmailMarketing {
    export class SendToEmmaModalController {
        static $inject = [
            '$mdDialog',
            "$timeout",
            "meevo.components.common.DataService",
            "meevo.components.busy.BusyService",
            "meevo.components.modal.ModalService",
            "$translate"
        ];

        public title: string;
        public clientExportRequest: any;
        public emmaGroups: Array<EmmaGroup>;
        public visibleEmmaGroups: Array<EmmaGroup>;
        public newGroupName: string;
        public loading: boolean = true;
        public groupCreated: boolean = false;
        public chooseReplace: boolean = false;
        public successLabel: string;

        constructor(private $mdDialog: ng.material.IDialogService,
            protected $timeout: ng.ITimeoutService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $translate: ng.translate.ITranslateService,
        ) {
            this.busyService.start();
            this.dataService.customMethodData("api/Emma/Groups", "GET", null).then((res) => {
                this.emmaGroups = this.visibleEmmaGroups = res.data;
                this.loading = false;
            }).catch(() => {
                this.modalService.error('LABEL_EMMA_GROUPCREATION_ERROR');
                this.$mdDialog.hide(false);
            }).finally(() => {
                this.busyService.stop();
            });
            
        }

        public close(): void {
            this.$mdDialog.cancel();
        }

        public replace(doReplace: boolean): void {
            var id = this.visibleEmmaGroups.filter(x => x.selected)[0].member_group_id;
            this.emmaGroups.map(x => x.selected = false);
            var dataToPost = {
                "GroupName": this.newGroupName,
                "DoReplace": doReplace,
                "GroupId": id
            }
            this.ok(dataToPost);
        }
        public ok(dataToPost: any = null): void {
            if (this.loading) return;
            var selected = this.emmaGroups.filter(x => x.selected)[0];
            if (selected) {
                this.chooseReplace = true;
                this.visibleEmmaGroups = this.emmaGroups.filter(x => x.selected);
            } else if (this.newGroupName) {
                var newGroup = false;
                if (!dataToPost) {
                    newGroup = true;
                    dataToPost = {
                        "GroupName": this.newGroupName
                    }
                };
                this.busyService.start();
                this.loading = true;
                dataToPost.ClientExportRequest = this.clientExportRequest;
                this.dataService.customMethodData("api/Emma/Group", "POST", dataToPost).then((res) => {
                    console.log('emma group created', res);
                    this.groupCreated = true;
                    this.successLabel = !newGroup ? this.$translate.instant('LABEL_EMMA_EXISTING_GROUP_SUCCESS') : this.$translate.instant('LABEL_EMMA_ADD_GROUP_SUCCESS');
                    this.$timeout(() => {
                        this.$mdDialog.hide(true);
                    }, 2000);
                }).catch(e => {
                    console.error('error creating emma group', e);
                    this.modalService.error('LABEL_EMMA_GROUPCREATION_ERROR');
                    this.$mdDialog.hide(false);
                }).finally(() => {
                    this.busyService.stop();
                });
                
            } else {
                this.modalService.alert('LABEL_EMMA_GROUPNAME_REQUIRED');
            }
        }

        public groupSelected(item: EmmaGroup): void {
            this.$timeout(() => {
                this.emmaGroups.forEach(x => {
                    if (x.member_group_id !== item.member_group_id) {
                        x.selected = false
                    } else {
                        x.selected = !x.selected;
                    }
                });
                this.newGroupName = item.selected ? item.group_name : '';
                if (!this.newGroupName) {
                    this.chooseReplace = false;
                    this.visibleEmmaGroups = this.emmaGroups;
                }
            }, 1);
        }

        public newGroupNameChanged(): void {
            this.$timeout(() => {
                this.emmaGroups.map(x => x.selected = false);
                if (!this.newGroupName) {
                    this.visibleEmmaGroups = this.emmaGroups;
                    this.chooseReplace = false;
                } else {    
                    this.visibleEmmaGroups = this.emmaGroups.filter(x => x.group_name.toLowerCase().indexOf(this.newGroupName.toLowerCase()) > -1);
                    this.visibleEmmaGroups.some(x => {
                        if (x.group_name.toLowerCase() == this.newGroupName.toLowerCase()) {
                            x.selected = true;
                            return true;
                        } 
                    });
                }
            }, 1);
        }
    }

    angular.module('meevo.plugins.basicEmailMarketing')
        .controller('meevo.plugins.basicEmailMarketing.SendToEmmaModalController', SendToEmmaModalController);


}
